export default [
  'ResourceService',
  '$q', '$window', '$rootScope',
  class CartAPIService {
    constructor(resourceService, $q, $window, $rootScope) {
      this._resourceService = resourceService;
      this._$q = $q;
      this._API_BASE = '/cart';
      this._$window = $window;
      this._$rootScope = $rootScope;

      this._totalsCanceler = $q.defer();
    }

    getTotal(campaignId, couponCode, state, country, cart, originalCID = null) {
      if (!campaignId || !cart) {
        return this._resourceService.errorPromise('cartAPI:getTotal: missing parameters');
      }

      let upsellCID = (originalCID != null) ? cart[0]['cid'] : null;
      return this._resourceService.get(`${this._API_BASE}/totals`, {
        params: {
          cc: couponCode,
          ships: state,
          shipc: country,
          upsell_cid: upsellCID,
          original_cid: originalCID,
          cart: cart
        },
        paramSerializer: '$httpParamSerializerJQLike',
        timeout: this._totalsCanceler.promise
      });
    }

    cancelGetTotal() {
      this._totalsCanceler.resolve({ data: 'promise cancelled' });
      this._totalsCanceler = this._$q.defer();
    }

    checkout(payload) {
      if (!payload) {
        return this._resourceService.errorPromise('cartAPI:checkout: missing parameters');
      }

      return this._resourceService.legacyPost(`/purchase/checkout2`, payload);
    }

    placeOrder(payload) {
      if (!payload) {
        return this._resourceService.errorPromise('cartAPI:placeOrder: missing parameters');
      }

      return this._resourceService.legacyPost(`/purchase/place-order2`, payload);
    }

    getAmazonTotal(amazonReferenceId, orderReferenceID, couponCode) {

      if (!amazonReferenceId || !orderReferenceID) {
        return this._resourceService.errorPromise('missing parameter');
      }

      return this._resourceService.get(`${this._API_BASE}/amazon-cart/${amazonReferenceId}/${orderReferenceID}`, {
        params: {
          cc: couponCode
        },
        paramSerializer: '$httpParamSerializerJQLike'
      });
    }

    amazonCheckout(payload) {
      return this._resourceService.post(`${this._API_BASE}/amazon-checkout`, payload);
    }

    processAmazonPayment(referenceID, orderID, coupon) {
      if (!referenceID || !orderID) {
        return this._resourceService.errorPromise('cartAPI:processAmazonPayment: missing parameters');
      }

      return this._resourceService.post(`${this._API_BASE}/amazon-order`, {
        app_reference_id: referenceID,
        amazon_order_ref_id: orderID,
        coupon_code: coupon
      });
    }

    paypalCheckout(payload) {
      if (!payload) {
        return this._resourceService.errorPromise('cartAPI:paypalCheckout: missing parameters');
      }

      return this._resourceService.post(`${this._API_BASE}/paypal-checkout`, payload);
    }

    paypalUpsellCheckout(payload) {
      if (!payload) {
        return this._resourceService.errorPromise('cartAPI:paypalUpsellCheckout: missing parameters');
      }

      return this._resourceService.post(`${this._API_BASE}/paypal-upsell-checkout`, payload);
    }

    paypalPaymentResource(paymentID) {
      if (!paymentID) {
        return this._resourceService.errorPromise('missing payment ID');
      }

      return this._resourceService.get(`${this._API_BASE}/paypal-payment-resource/${paymentID}`);
    }

    placePaypalOrder(payload) {
      if (!payload) {
        return this._resourceService.errorPromise('cartAPI:placePaypalOrder: missing parameters');
      }

      return this._resourceService.post(`${this._API_BASE}/paypal-order`, payload);
    }

    createCCToken(card, customer) {
      let deferred = this._$q.defer(),
        merchant;

      this._resourceService.get(`/merchant`)
        .then((res) => {
          merchant = res.merchant;

          switch (merchant) {
            case 'STRIPE':
              return this._createStripeToken(card, res.token);
              break;
            case 'BRAINTREE':
              return this._createBraintreeToken(card, res.token);
              break;
            case 'WORLDPAY':
              return this._createWorldpayToken(card, res.token, customer);
              break;
          }
        })
        .then((token) => deferred.resolve({ token, merchant }))
        .catch((error) => deferred.reject(error));

      return deferred.promise;
    }

    _assignJsonpParams(url, payload) {
      for (let key in payload) {
        url += `${key}=${payload[key]}&`;
      }

      url = url.slice(0, -1);

      return url;
    }

    _createWorldpayToken(card, token, customer) {
      let deferred = this._$q.defer(),
        customerName = `${customer.firstName} ${customer.lastName}`,
        expMM = `${card.cc_expiry_mm}`,
        expYY = `${card.cc_expiry_yy}`,
        worldPayApiUrl = 'https://prod.moderntransact.com/ws',
        sharedPayload = {
          payscriptToken: token,
          ResponseType: 'json',
          mycallback: 'JSON_CALLBACK',
        },
        createCustomerUrl = `${worldPayApiUrl}/recurring.asmx/ManageCustomer?`,
        createTokenUrl = `${worldPayApiUrl}/cardsafe.asmx/StoreCard?`,
        createCustomerPayload = Object.assign({
          TransType: 'ADD',
          Vendor: 1,
          Company: 'VS',
          CustomerName: customerName,
          FirstName: customer.firstName,
          LastName: customer.lastName,
        }, sharedPayload),
        createTokenPayload = Object.assign({
          TokenMode: 'DEFAULT',
          NameOnCard: customerName,
          CardNum: card.cc_num,
          ExpDate: `${expMM.length > 1 ? expMM : `0${expMM}`}${expYY.slice(2, 4)}`,
          Street: customer.address,
          PostalCode: customer.zip,
        }, sharedPayload);

      createCustomerUrl = this._assignJsonpParams(createCustomerUrl, createCustomerPayload)

      // create customer
      this._resourceService.jsonp(createCustomerUrl).then(res => {
        if (res.data.error === 'OK') {
          createTokenPayload.CustomerKey = res.data.CustomerKey;

          createTokenUrl = this._assignJsonpParams(createTokenUrl, createTokenPayload);

          // create token
          this._resourceService.jsonp(createTokenUrl).then(res => {
            if (res.data.error === 'OK') {
              deferred.resolve(`wpt_${res.data.CardSafeToken}`);
            } else {
              deferred.reject(res.data.error);
            }
          });
        } else {
          deferred.reject(res.data.error);
        }
      });

      return deferred.promise;

    }

    _createStripeToken(card, key) {
      let deferred = this._$q.defer();
      this._$window.Stripe.setPublishableKey(key);

      this._$window.Stripe.card.createToken({
        number: card.cc_num,
        cvc: card.cc_cvc,
        exp_month: card.cc_expiry_mm,
        exp_year: card.cc_expiry_yy
      }, (status, res) => {
        if (res.error) {
          deferred.reject(res.error);
        } else {
          deferred.resolve(res.id);
        }
      });

      return deferred.promise;
    }

    _createBraintreeToken(card, token) {
      let deferred = this._$q.defer();
      let btClient = new this._$window.braintree.api.Client({ clientToken: token });

      btClient.tokenizeCard({
        number: card.cc_num,
        cvv: card.cc_cvc,
        expirationMonth: card.cc_expiry_mm,
        expirationYear: card.cc_expiry_yy
      }, (err, nonce) => {
        if (err) deferred.reject(err);
        else deferred.resolve(nonce);
      });

      return deferred.promise;
    }
  }
];


// WEBPACK FOOTER //
// ./source/client/api-services/cart-service.js